import { useContext, useEffect, useRef } from 'react';
import InventoryContext from '~/context/srp/InventoryContext';
import { useIsLoggedIn } from '~/context/srp/UserContext';
import { logError, toError } from '~/utilities/srp/errorHandlers';

// resets inventory pricing on log in or log out so we refetch pricing
const useResetInventoryPricing = (vehicleIds: number[]) => {
  const isLoggedIn = useIsLoggedIn();
  const { resetInventoryPricing } = useContext(InventoryContext);
  const vehicleIdsRef = useRef(vehicleIds);
  useEffect(() => {
    vehicleIdsRef.current = vehicleIds;
  }, [vehicleIds]);

  useEffect(() => {
    if (vehicleIdsRef.current.length === 0) return;

    try {
      resetInventoryPricing();
    } catch (err) {
      logError(toError(err), { location: 'Pricing reset' });
    }
  }, [isLoggedIn, resetInventoryPricing]);
};

export default useResetInventoryPricing;
